/*Bug #603 - Create a common component for Address fields - Author Jithin Kuriakose on 05Sept2021*/
const countryFormtype = { us: "type1", in: "type2" };
/**
  * Bug #503
  * @Author Anupama P
  * @Date 06 Sep 2021
  */
const formType = {
    type1: {
        name: [
            {
                placeholder: "First Name *",
                key: "firstName",
                columnSize: 4,
                rules: [
                    {
                        required: true,
                        message: "Enter first name",
                    },
                ],
            },
            {
                placeholder: "Last Name *",
                key: "lastName",
                columnSize: 4,
                rules: [
                    {
                        required: true,
                        message: "Enter last name",
                    },
                ],
            },
            {
                placeholder: "Middle Name",
                key: "middleName",
                columnSize: 4,
            },
        ],
        address: [
            {
                placeholder: "Address1 *",
                key: "address1",
                columnSize: 6,
                rules: [
                    {
                        required: true,
                        message: "Enter Address",
                    },
                ],
            },
            {
                placeholder: "Address2",
                key: "address2",
                columnSize: 6,
            },
            {
                label: "City",
                key: "city",
                columnSize: 3,rules: [
                    {
                        required: true,
                        message: "Enter City",
                    },
                ],
            },
            {
                label: "State",
                key: "state",
                columnSize: 3,rules: [
                    {
                        required: true,
                        message: "Enter State",
                    },
                ],
            },
            {
                label: "Zip",
                key: "zipCode",
                columnSize: 3,rules: [
                    {
                        required: true,
                        message: "Enter Zip",
                    },
                ],
            },
            {
                label: "Country",
                key: "country",
                columnSize: 3,rules: [
                    {
                        required: true,
                        message: "Enter Country",
                    },
                ],
            },
        ],
        race: {
            key: "race",
            columnSize: 6,
        },
        ethnicity: {
            key: "ethnicity",
            columnSize: 6,
        },
    },
    type2: {
        name: [
            {
                placeholder: "First Name",
                key: "firstName",
                columnSize: 4,
                rules: [
                    {
                        required: true,
                        message: "Enter first name",
                    },
                ],
            },
            {
                placeholder: "Middle Name",
                key: "middleName",
                columnSize: 4,
            },
            {
                placeholder: "Last Name",
                key: "lastName",
                columnSize: 4,
                rules: [
                    {
                        required: true,
                        message: "Enter last name",
                    },
                ],
            },
        ],
        address: [
            {
                placeholder: "Address1",
                key: "address1",
                columnSize: 6,
                rules: [
                    {
                        required: true,
                        message: "Enter Address",
                    },
                ],
            },
            {
                placeholder: "Address2",
                key: "address2",
                columnSize: 6,
            },
            {
                label: "City",
                key: "city",
                columnSize: 3,
                rules: [
                    {
                        required: true,
                        message: "Enter City",
                    },
                ],
            },
            {
                label: "Country",
                key: "country",
                columnSize: 3,
                rules: [
                    {
                        required: true,
                        message: "Enter Country",
                    },
                ],
            },
            {
                label: "State",
                key: "state",
                columnSize: 3,
                rules: [
                    {
                        required: true,
                        message: "Enter State",
                    },
                ],
            },
            {
                label: "Zip",
                key: "zipCode",
                columnSize: 3,
                rules: [
                    {
                        required: true,
                        message: "Enter Zip",
                    },
                ],
            },
        ],
    },
};
/*For saving insurance subscriber Address fields - Author Aby Joseph on 16 Sep 2021*/
export const NameCustomkeys = {firstName: "insuredFirstName", lastName: "insuredLastName", middleName:"insuredMiddleName"};
export const AddressCustomkeys = {address1: "insuredAddress1", address2: "insuredAddress2", city:"insuredCity",state:"insuredState",zipCode:"insuredZipCode",country:"insuredCountry"};
export const DobCustomkeys = {dateOfBirth: "insuredDob"};
export const GenderCustomkeys = {gender: "insuredGender"};
/*For saving insurance subscriber Address fields - End*/

export const getCountryCode = () => {
    return "us";
};
export const getFormTypeBasedOnCountry = (countryCode) => {
    if (countryFormtype.hasOwnProperty(countryCode)) {
        return countryFormtype[countryCode];
    }
    return "type1";
};
export const getFormFields = (countryCode, componentType) => {
    const type = getFormTypeBasedOnCountry(countryCode);
    if (
        formType.hasOwnProperty(type) &&
        formType[type].hasOwnProperty(componentType)
    ) {
        return formType[type][componentType];
    }
    return;
};
/*End Bug #603 */

/*For saving insurance subscriber Address fields - Author Aby Joseph on 16 Sep 2021*/
export const getKeyName = (customkeys, keyName) =>{
    if(customkeys?.hasOwnProperty(keyName)){
        return customkeys[keyName];
    }else{
        return keyName;
    }
};
/*end*/